export default {
    healthRiskAssessment: {
        started: "HRA_STARTED",
        resumed: "HRA_RESUMED",
        saved: "HRA_SAVED",
        completed: "HRA_COMPLETED"
    }
};
